import styled from 'styled-components'

export const BackButtonContainer = styled.button`
    border: none;
    background: transparent;
    height: min-content;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-family: ${properties => properties.theme.variables.fontFamily.title};
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: ${properties => properties.theme.variables.colorText};
    svg {
        path {
            fill: ${properties => properties.theme.variables.colorText};
        }
    }
    &:disabled {
        color: ${properties => properties.theme.variables.colorGray.primary};
        cursor: default;
        &:hover {
            color: none;
        }
    }
`

export const GoBackMessage = styled.p`
    font-weight: bolder;
    margin-left: 0.2rem;
    font-size: 0.9rem;
    line-height: 1.2em;
`
